import { ArrowTitle, PeriodContainer } from "./Period.styled";
import { PeriodItem } from "./PeriodItem";
import { PricingActualPlans, PricingActualTypePeriod } from "../../../interfaces";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { useTranslation } from "react-i18next";
import { PromoCode } from "../../../components/common";

interface PeriodProps {}

export const Period = observer(({}: PeriodProps) => {
	const { pricingActualStore } = useStores();

	const { t } = useTranslation();

	const discount = [PricingActualPlans.PACKS, PricingActualPlans.SKILL_BUNDLES].includes(pricingActualStore.plans)
		? 50
		: 25;

	return (
		<PeriodContainer>
			<PeriodItem
				name={PricingActualTypePeriod.MONTHLY}
				title={t(`pages.pricing.${PricingActualTypePeriod.MONTHLY}`)}
				isActive={pricingActualStore.typePeriod === PricingActualTypePeriod.MONTHLY}
				value={1}
			/>
			<PeriodItem
				name={PricingActualTypePeriod.ANNUAl}
				title={t(`pages.pricing.${PricingActualTypePeriod.ANNUAl}`)}
				isActive={pricingActualStore.typePeriod === PricingActualTypePeriod.ANNUAl}
				value={2}
			/>
			<ArrowTitle>{t("pages.pricing.save_up", { percent: discount })}</ArrowTitle>
			<PromoCode />
		</PeriodContainer>
	);
});
